export const ColorsRaw = {
  anthracite: {
    Anthracite_1: '#140505',
    Anthracite_2: '#1B0D0D',
    Anthracite_3: '#251919',
    Anthracite_4: '#3C3334',
    Anthracite_5: '#9E8F86',
    Warm_Anthracite: '#210909',
    Warm_Anthracite_2: '#322222',
  },
  basic: {
    Cream: '#FFEFE6', // use for all text
    White: '#ffffff',
    Black: '#000000',
  },
  main: {
    Navy_Dark: '#3A56A5',
    Navy_Light: '#7995E4',
  },
  secondary: {
    Light_Grey: '#CAC4D0',
    Light_Purple: '#8C8291',
    Logo_Blue: '#005FAB',
  },
  error: {
    Error: '#B81C2F',
    Error_on: '#E98B96',
  },
  scores: {
    Green: '#41D650',
    Lime: '#CBEA4E',
    Mandarine: '#EAB54E',
    Orange: '#F4805B',
    Pink: '#B81C64',
    Anthracite_4: '#3C3334',
    Green_012: 'rgba(65, 214, 80, 0.12)', // 012 for alpha 0.12 or #41D6501A
    Lime_012: 'rgba(203, 234, 78, 0.12)',
    Mandarine_012: 'rgba(234, 181, 78, 0.12)',
    Orange_012: 'rgba(244, 128, 91, 0.12)',
    Pink_012: 'rgba(184, 28, 100, 0.12)',
    Antracite_4012: 'rgba(158, 143, 134, 0.12)',
  },
  scoresGauge: {
    Background: '#FFFFFF14',
    upTo25: '#C53059',
    upTo50: '#DA761A',
    upTo75: '#347F81',
    upTo100: '#40B853',
  },
  parityBar: {
    Women: '#4CC4D2',
    Men: '#CBEA4E',
    Other: '#9E8F86',
  },
};
